import { render, staticRenderFns } from "./collectImgAj.vue?vue&type=template&id=0acd2607&scoped=true"
import script from "./collectImgAj.vue?vue&type=script&lang=js"
export * from "./collectImgAj.vue?vue&type=script&lang=js"
import style0 from "./collectImgAj.vue?vue&type=style&index=0&id=0acd2607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd2607",
  null
  
)

export default component.exports